<template>
    <slot v-bind="{ ...state }" />
</template>

<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount, reactive } from 'vue';

import favorites from '../services/favorites';

const props = defineProps({
    id: {
        type: String,
    },
});

const state = reactive({
    isFavorited: false,
});

const handleFavoritesChange = () => {
    state.isFavorited = favorites.isFavoriteArtist({ id: props.id });
}

onBeforeMount(() => {
    state.isFavorited = favorites.isFavoriteArtist({ id: props.id });
});

onMounted(() => {
    window.addEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});

onBeforeUnmount(() => {
    window.removeEventListener(favorites.favoritePerformancesChangedEventName, handleFavoritesChange);
});
</script>
